var map = {
	"./2123_mskobr.png": 603,
	"./26_mbou.png": 604,
	"./kodini.png": 605,
	"./metallurg.png": 606,
	"./o-brain.png": 607,
	"./qtime.png": 608,
	"./qtime_estonia.png": 609,
	"./robotorium.png": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 734;